import React from 'react'
import checkPermission from '../../../../../../utilities/checkPermission'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useAppFolderAndTabAction from '../../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import { DialogType } from '../../../../../../control/dialog/dialog'
import useLoading from '../../../../../../control/loading/useLoading'
import useWebService from '../../../../../../services/web/useWebService'
import * as REQServiceType from '../../../../../../services/web/types/requestWebServiceTypes'
import authenStore from '../../../../../../stores/authen/authenStore'
import useTranslate from '../../../../../../i18n/useTranslate'
import SecretCodeForm from '../../../../shareUI/secretCodeForm/secretCodeForm'

// --- Contants --- //
import constSubmittedStep from '../../../../../../constants/submittedStep'
import { SignRepresentREC1Type } from './signRepresentREC1'
import { encryption } from '../../../../../../utilities/encryption'
import { memorandumTopic } from '../../../../../../constants/constants'
import { memoMessagePaperInfoType } from '../../../../../../services/web/types/responseWebServiceTypes'
import { UploadFileObjCerType } from '../../generateCertificate/generateCertificateType'

type CerDialogType = Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>
const useSignRepresent = (props: SignRepresentREC1Type) => {
    const { callbackSaveComplete } = props
    const [initialValues, setInitialValues] = React.useState<any>({})
    const manageProjectStore = useManageProjectStore()
    const { projectData } = manageProjectStore
    const checkPermissionHook = checkPermission()
    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const [configDialog, setConfigDialog] = React.useState<CerDialogType>()
    const dialogRef = React.useRef<Record<string, Function>>()
    const loadingHook = useLoading()
    const callWebService = useWebService()
    const profileStore = authenStore()
    const translate = useTranslate()

    const [initialMemorandumFile, setInitialMemorandumFile] = React.useState<any>()

    React.useEffect(() => {
        createInitialData()
    }, [])
    const createInitialData = async () => {
        if (projectData && projectData?.stepID === constSubmittedStep.sign) {
            const submittedID = projectData.submittedID
            const projectID = projectData.projectID
            loadingHook.loadingOpen()
            const { result, status } = await callWebService.getSignMemomessage(projectID, submittedID)

            loadingHook.loadingClose()
            if (status === 1) {
                const initialData = {
                    // chairmanSign: result.isSignBeHalfPresident,
                    secretarySign: result.isSignBeHalfSecretary,
                }
                const initialMemorandumFile = createInitialFileData(result.memoMessagePaperInfo)
                setInitialMemorandumFile(initialMemorandumFile)
                setInitialValues(initialData)
            }
        }
    }

    const createInitialFileData = (memoMessagePaperInfo: memoMessagePaperInfoType) => {
        const uploadFileMemoranduminit: Array<UploadFileObjCerType> = memorandumTopic?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                },
            }
        })
        uploadFileMemoranduminit.forEach((itm: UploadFileObjCerType) => {
            if (itm.uploadFileObj.documentTopicID === 0) {
                if (memoMessagePaperInfo?.certificateSignFileName_th) {
                    let fileListTH = {
                        documentTopicID: 0,
                        fileToken: memoMessagePaperInfo?.certificateSignFileName_th,
                        filename: memoMessagePaperInfo?.certificateSignFileName_th,
                        fileID: memoMessagePaperInfo?.certificateSignFileName_th,
                        path: memoMessagePaperInfo?.cerSign_th,
                    }
                    //@ts-ignore
                    itm.uploadFileObj.fileList.push(fileListTH)
                }
            } else if (itm.uploadFileObj.documentTopicID === 1) {
                if (memoMessagePaperInfo?.certificateSignFileName_en) {
                    let fileListEN = {
                        documentTopicID: 1,
                        fileToken: memoMessagePaperInfo?.certificateSignFileName_en,
                        filename: memoMessagePaperInfo?.certificateSignFileName_en,
                        fileID: memoMessagePaperInfo?.certificateSignFileName_en,
                        path: memoMessagePaperInfo?.cerSign_en,
                    }
                    //@ts-ignore
                    itm.uploadFileObj.fileList.push(fileListEN)
                }
            }

            itm.uploadFileObj.subTopicPageList = []
        })
        return uploadFileMemoranduminit
    }

    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }
    const handleDirtyChange = (props: { dirty: boolean }) => {
        appFolderAndTabAction.setTabDirty(props.dirty)
    }
    const handleSubmitForm = async (val: any) => {
        const signBehalfCertificateRequest: REQServiceType.SignMemomessageType = {
            projectID: projectData?.projectID || null,
            signUserID: profileStore.profile.userId,
            submittedID: projectData?.submittedID || null,
            isSignBehalfSecretary: val?.secretarySign,
            signUserPinCode: null,
        }
        if (val.saveType === 'SAVE') {
            setConfigDialog({
                title: translate.get('LABEL.SECRET_PASSWORD'),
                content: React.createElement(SecretCodeForm, {
                    onClickClose: () => {
                        dialogRef.current?.closeDialog()
                    },
                    onClickSave: (val: any) => {
                        handleSubmitSecretCode({
                            ...signBehalfCertificateRequest,
                            signUserPinCode: encryption(val.password),
                        })
                    },
                }),
                type: '',
            })
            dialogRef.current?.openDialog()
        }
    }
    const handleSubmitSecretCode = async (paramForSave: any) => {
        dialogRef.current?.closeDialog()
        loadingHook.loadingOpen()
        const res = await callWebService.signMemomessage(paramForSave)

        loadingHook.loadingClose()
        conditionDialog(res?.status)
    }
    const conditionDialog = (status: number) => {
        if (status === 1) {
            if (status && callbackSaveComplete) {
                setDefaultPage()
                createInitialData()
                callbackSaveComplete(status, false)
            }
        } else if (status === -2) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.WARNING'),
                content: translate.get('ALERT.CONTENT.SECRET_PASSWORD_INCORRECT'),
                type: 'alert-message',
            })
            dialogRef.current?.openDialog()
        } else {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.ERROR'),
                content: translate.get('ALERT.CONTENT.SAVE_NOT_SUCCESS'),
                type: 'alert-message',
            })
            dialogRef.current?.openDialog()
        }
    }

    const setDefaultPage = () => {
        setConfigDialog({}) //clear function dialog
        // loadLatestFolder()
        appFolderAndTabAction.resetTabDirty()
    }
    return {
        onRefDialog,
        configDialog,
        isViewMode,
        initialValues,
        handleDirtyChange,
        onSubmitForm: handleSubmitForm,
        initialMemorandumFile,
        projectData,
        memorandumTopic,
    }
}
export default useSignRepresent
